var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import React, { useState, useEffect, Component } from "react";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames2.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
            classes.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
const TestErrorDispatcher = () => {
  const [shouldThrow, setShouldThrow] = useState(false);
  useEffect(() => {
    const throwLater = shouldThrow;
    setShouldThrow(false);
    if (throwLater) {
      throw new Error("Local error in component lifecycle");
    }
  }, [shouldThrow]);
  useEffect(() => {
    window.testErrorDispatcher = {
      global() {
        setTimeout(() => {
          throw new Error("Global error in application");
        }, 0);
      },
      lifecycle() {
        setShouldThrow(true);
      }
    };
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
};
const TestErrorDispatcher$1 = TestErrorDispatcher;
const colAccent = "var(--illu-color-accent)";
const colDark = "var(--illu-color-dark)";
const colHammer = "var(--illu-color-hammer)";
const colClothing = "var(--illu-color-clothing)";
function BugSvg() {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1022.7 785.8" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "a",
      x1: "678.2",
      x2: "678.2",
      y1: "821.8",
      y2: "493.4",
      gradientTransform: "rotate(-2.3 725.2 516.8)",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { offset: "0", stopColor: "gray", stopOpacity: ".3" }),
    /* @__PURE__ */ React.createElement("stop", { offset: ".5", stopColor: "gray", stopOpacity: ".1" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "gray", stopOpacity: ".1" })
  )), /* @__PURE__ */ React.createElement(
    "ellipse",
    {
      cx: "468.6",
      cy: "660.9",
      fill: colAccent,
      opacity: ".1",
      rx: "425",
      ry: "33"
    }
  ), /* @__PURE__ */ React.createElement("g", { opacity: ".1" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M845 472.8c-2.5-7.7-12.8-11.2-23-7.9a24.8 24.8 0 0 0-4.2 1.8l-2-.4a22.4 22.4 0 0 0 .7-6.8 24.6 24.6 0 0 0 10.9-21.5 24.6 24.6 0 0 0 10.8-21.4 23.8 23.8 0 0 0 8.2-9.4c5-9.7 3-20.6-4.5-24.3s-17.4 1-22.3 10.8a23.7 23.7 0 0 0-2.6 12.1 24.6 24.6 0 0 0-10.9 21.5 24.6 24.6 0 0 0-10.8 21.5 24.6 24.6 0 0 0-11 21.4 23.8 23.8 0 0 0-8.2 9.4 25.5 25.5 0 0 0-2 5.7 21.2 21.2 0 0 0-4.5-4.7 25.4 25.4 0 0 0-1-4.5c-3.3-10.2-12.3-16.4-20-13.9s-11.3 12.9-8 23a23 23 0 0 0 7.6 11.1 25.4 25.4 0 0 0 1 4.5 22 22 0 0 0 10.2 12.8 23.2 23.2 0 0 0-.8 3.9 25.3 25.3 0 0 0-7.6 14.9 25.3 25.3 0 0 0-7.5 14.9 24.6 24.6 0 0 0-5 6.8c-5 9.7-2.9 20.6 4.5 24.4s17.4-1.1 22.3-10.8a24.6 24.6 0 0 0 2.5-8.1 25.3 25.3 0 0 0 7.6-15 25.3 25.3 0 0 0 7.5-14.8 25.2 25.2 0 0 0 7.5-15 25.2 25.2 0 0 0 7.5-14.9 24.1 24.1 0 0 0 3.4-4 23.5 23.5 0 0 0 12.3-.8 24.8 24.8 0 0 0 4.2-1.8 23.2 23.2 0 0 0 13.4-.5c10.1-3.3 16.4-12.2 13.9-20Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M827.1 442.4a21.5 21.5 0 0 1-3.4 2.8 23 23 0 0 1-1.1 8.4 26.2 26.2 0 0 0 2-3.4 24.6 24.6 0 0 0 2.5-7.8ZM838 421a21.5 21.5 0 0 1-3.5 2.7 23 23 0 0 1-1 8.5 25.6 25.6 0 0 0 2-3.5 24.9 24.9 0 0 0 2.5-7.7Zm-24.6-8a22 22 0 0 1 .1-4.4 25 25 0 0 0-4.8 6.5 25.6 25.6 0 0 0-1.5 3.8 22.8 22.8 0 0 1 6.1-6Zm-69 130a23.6 23.6 0 0 1 3-3.5 23 23 0 0 1 .8-4 25 25 0 0 0-2.2 3.7 25.6 25.6 0 0 0-1.6 3.7Zm7.6-15a23.6 23.6 0 0 1 3-3.4 23 23 0 0 1 .7-3.9 25.7 25.7 0 0 0-2.2 3.6 26.8 26.8 0 0 0-1.5 3.7Zm64.3-64a20.8 20.8 0 0 1-3.5 2.6 22.4 22.4 0 0 1-.6 6.8 18.8 18.8 0 0 1 2 .5 24.8 24.8 0 0 1 4.2-1.8c10.2-3.4 20.5.2 23 7.9a11.7 11.7 0 0 1 .3 6c3.4-4 4.8-8.7 3.3-13.1-2.5-7.8-12.8-11.3-23-8a24.8 24.8 0 0 0-4.2 1.9l-2-.5.5-2.4Zm-75.6 86.4a25 25 0 0 0-2.3 3.7 26.6 26.6 0 0 0-1.5 3.7 24.5 24.5 0 0 1 3-3.3 23 23 0 0 1 .8-4.1Zm61.7-115.9a22 22 0 0 1 .2-4.5 25 25 0 0 0-4.8 6.6 25.6 25.6 0 0 0-1.5 3.7 22.8 22.8 0 0 1 6.1-5.8ZM786.8 522a24.3 24.3 0 0 1-1 4.4 26.7 26.7 0 0 0 2-3.4 25.5 25.5 0 0 0 1.7-4 24.2 24.2 0 0 1-2.8 3Zm-15.1 29.8a24.1 24.1 0 0 1-1 4.4 25.6 25.6 0 0 0 2-3.4 26.5 26.5 0 0 0 1.7-4 23.6 23.6 0 0 1-2.7 3Zm7.5-14.8a24.1 24.1 0 0 1-1 4.3 26.7 26.7 0 0 0 2.1-3.4 25.5 25.5 0 0 0 1.7-4 24.2 24.2 0 0 1-2.8 3Zm15.1-29.9a24 24 0 0 1-1 4.4 25.9 25.9 0 0 0 2-3.5 25.5 25.5 0 0 0 1.7-4 23.2 23.2 0 0 1-2.7 3.1ZM745 469.4c7.6-2.5 16.6 3.7 20 13.8a25.7 25.7 0 0 1 1 4.5 21.2 21.2 0 0 1 4.4 4.8 25.5 25.5 0 0 1 2-5.8l1.2-2a21 21 0 0 0-4-4.2 25.4 25.4 0 0 0-1-4.5c-3.4-10.1-12.3-16.3-20-13.8-4.4 1.4-7.5 5.4-8.7 10.4a11.7 11.7 0 0 1 5-3.2Zm35.7 8a21.9 21.9 0 0 1 .2-4.4 24.7 24.7 0 0 0-4.8 6.6 25 25 0 0 0-1.5 3.7 23 23 0 0 1 6.1-6Zm10.9-21.4a21.9 21.9 0 0 1 .2-4.5 24.5 24.5 0 0 0-4.8 6.6 25.6 25.6 0 0 0-1.5 3.7 22.8 22.8 0 0 1 6-5.9Zm-27.5 110.7a24.3 24.3 0 0 1-1 4.4 25.7 25.7 0 0 0 3.8-7.5 23.6 23.6 0 0 1-2.8 3.1Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M859.9 373.6a23.7 23.7 0 0 0 8.2-9.3c5-9.7 2.9-20.6-4.5-24.4s-17.4 1.1-22.3 10.8a23.7 23.7 0 0 0-2.7 12.2 24.6 24.6 0 0 0-10.8 21.5 23.6 23.6 0 0 0-8.2 9.3 24.7 24.7 0 0 0-1.6 3.7 20.9 20.9 0 0 1 10.8-8 12.2 12.2 0 0 0 15.6 7.8 20.9 20.9 0 0 1 0 13.4 25.5 25.5 0 0 0 2-3.4 23.7 23.7 0 0 0 2.7-12.1 24.6 24.6 0 0 0 10.8-21.5Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M979.2 236a72 72 0 0 0 8.8-4.9l-32.4-23.6 38 19.6a72.1 72.1 0 0 0 27-50.3l-64.6.6 64.8-10.8A72 72 0 1 0 878.2 185a72 72 0 0 0-13.3 8l33.8 47-40.6-41.1a72 72 0 0 0-20.1 65.6 72 72 0 1 0 101 51 72 72 0 0 0 40.2-79.4Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M844.4 217.7a71.8 71.8 0 0 0-6.4 46.7 72 72 0 1 0 101 51c14.2-6.5-91-105-94.6-97.7Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: "925.5", cy: "102.7", r: "10.7", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "987.9", cy: "109.6", r: "10.7", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "1012", cy: "205.6", r: "10.7", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "979.5", cy: "253.6", r: "10.7", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "935.1", cy: "353.2", r: "10.7", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "935.1", cy: "353.2", r: "10.7", opacity: ".1" }), /* @__PURE__ */ React.createElement("circle", { cx: "836.4", cy: "240.4", r: "10.7", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "836.4", cy: "240.4", r: "10.7", opacity: ".1" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M825 416.2c-7.1-3.6-9.3-13.7-5.1-23.1l-.6 1.2c-5 9.7-3 20.6 4.5 24.3s17.4-1 22.3-10.8l.5-1.2c-5 9-14.5 13.2-21.6 9.6Zm-10.6 20.9c-7-3.6-9.2-13.8-5-23.1l-.7 1.1c-5 9.7-2.9 20.7 4.5 24.4s17.4-1 22.3-10.8l.6-1.2c-5.1 9-14.6 13.2-21.7 9.6ZM803.9 458c-7.1-3.6-9.3-13.8-5.1-23.2l-.7 1.2c-4.9 9.7-2.8 20.6 4.6 24.4s17.4-1.1 22.3-10.8l.5-1.2c-5 8.9-14.5 13.2-21.6 9.6Zm-10.5 21c-7.2-3.7-9.3-13.9-5.2-23.2l-.6 1.1c-4.9 9.7-2.9 20.7 4.5 24.4s17.4-1 22.3-10.8l.6-1.2c-5.1 8.9-14.6 13.1-21.6 9.6Zm-10.6 20.7c-7.1-3.6-9.3-13.7-5.1-23.1l-.7 1.2c-4.9 9.7-2.9 20.6 4.5 24.3s17.4-1 22.4-10.8l.5-1.2c-5 9-14.5 13.2-21.6 9.6Zm-10.6 20.9c-7.1-3.6-9.3-13.8-5.1-23.1l-.6 1.1c-5 9.7-3 20.7 4.5 24.4s17.4-1 22.4-10.8l.5-1.2c-5.1 9-14.5 13.2-21.7 9.6Zm-10.6 20.9c-7-3.6-9.2-13.8-5-23.2l-.7 1.2c-4.9 9.7-2.9 20.6 4.5 24.4s17.4-1.1 22.3-10.8l.6-1.2c-5 8.9-14.5 13.2-21.7 9.6ZM751 562.4c-7-3.6-9.2-13.8-5-23.2l-.6 1.2c-5 9.7-3 20.6 4.5 24.4s17.4-1.1 22.3-10.8l.5-1.2c-5 8.9-14.5 13.1-21.6 9.6Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M744.1 576c-7-3.5-9.2-13.7-5-23l-.7 1.1c-4.9 9.7-2.9 20.6 4.5 24.4s17.4-1.1 22.3-10.8l.6-1.2c-5 8.9-14.5 13.2-21.6 9.6Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M935 483.2a37.4 37.4 0 0 0 2-9.8 5.3 5.3 0 1 0-.9-10.6 37.3 37.3 0 0 0-19.6-25.4 5.3 5.3 0 1 0-9.5-4.8 5 5 0 0 0-.5 1.5 37.5 37.5 0 0 0-32.9 9.8 37.6 37.6 0 0 0-9.8-.3l-4.3 19.7-.3-19a37.4 37.4 0 1 0 20 72 5.3 5.3 0 0 0 2.2 2.2 5.3 5.3 0 0 0 7.4-6.9 37.4 37.4 0 0 0 4.8-4 37.5 37.5 0 0 0 39.3-19.7l-20.2-3.4Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M903.8 492.7c-7.4-9.8-12-21.4-17.2-32.6a136.4 136.4 0 0 0-7.1-13.3l-4-4.6-2 1.7a37.6 37.6 0 0 0-9.8-.3l-4.3 19.7-.3-19a37.4 37.4 0 1 0 20 72 5.3 5.3 0 0 0 2.3 2.2 5.3 5.3 0 0 0 7.3-6.9 37.4 37.4 0 0 0 4.8-3.9 37.5 37.5 0 0 0 22.4-3.3 52.7 52.7 0 0 1-12-11.7Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M772 450.5a5.3 5.3 0 0 0-4.7-7.7 37.4 37.4 0 0 0-11.7-20.8 37.5 37.5 0 0 0 1-11.7l-19.6-3.4 19.1-1.2a38 38 0 0 0-1.4-5.3 5.5 5.5 0 0 0 1.8-2 5.3 5.3 0 0 0-6.6-7.4 37.4 37.4 0 0 0-66.8 31 5.3 5.3 0 0 0-2.7 2.4 5.3 5.3 0 0 0 6.8 7.4 37.5 37.5 0 0 0 7 8.6 37.4 37.4 0 0 0 1.8 23.8l26.4-6.8-23.5 12.3a37.4 37.4 0 0 0 68.9-16.3 5.3 5.3 0 0 0 4.3-2.9Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M772 450.5a5.3 5.3 0 0 0-4.7-7.7 37.4 37.4 0 0 0-11.7-20.8l.4-2a13.2 13.2 0 0 0-2 1.8c-3.5 3.9-5.3 9.1-8.8 13-4.1 4.7-10.3 7.1-16.5 7.7s-12.5-.3-18.6-1.4c-5-1-10.2-2.2-15.3-1.7l-1.4.2.9.8a37.4 37.4 0 0 0 1.7 23.8l26.4-6.8-23.5 12.3a37.4 37.4 0 0 0 68.9-16.3 5.3 5.3 0 0 0 4.3-2.9Z",
      opacity: ".1"
    }
  )), /* @__PURE__ */ React.createElement("g", { opacity: ".1" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M89.5 511.2c1.3-3.8 6.5-5.6 11.6-4a12.8 12.8 0 0 1 2.1 1l1-.3a11.3 11.3 0 0 1-.3-3.4 12.5 12.5 0 0 1-5.5-10.8 12 12 0 0 1-4.1-4.7 12 12 0 0 1-1.4-6.1 12 12 0 0 1-4-4.7c-2.6-4.9-1.6-10.4 2.2-12.3s8.8.6 11.2 5.4a12 12 0 0 1 1.4 6.2 12.4 12.4 0 0 1 5.4 10.8 12.4 12.4 0 0 1 5.5 10.8 12.4 12.4 0 0 1 5.5 10.8 12 12 0 0 1 4.1 4.7 12.7 12.7 0 0 1 1 3 10.7 10.7 0 0 1 2.2-2.5 12.6 12.6 0 0 1 .6-2.3c1.7-5 6.2-8.2 10-7s5.7 6.5 4 11.6a11.7 11.7 0 0 1-3.7 5.6 12.7 12.7 0 0 1-.6 2.3 11.1 11.1 0 0 1-5 6.4 12.8 12.8 0 0 1 .3 2 12.6 12.6 0 0 1 2.6 3.4 12.3 12.3 0 0 1 1.2 4.1 12.6 12.6 0 0 1 2.6 3.4 12.4 12.4 0 0 1 1.2 4.1 12.4 12.4 0 0 1 2.6 3.5c2.4 4.9 1.4 10.4-2.3 12.2s-8.8-.5-11.3-5.4a12.5 12.5 0 0 1-1.2-4 12.7 12.7 0 0 1-3.8-7.6 12.7 12.7 0 0 1-3.8-7.5 12.6 12.6 0 0 1-2.6-3.4 12.7 12.7 0 0 1-1.2-4.1 12.6 12.6 0 0 1-2.5-3.4 12.3 12.3 0 0 1-1.3-4.1 11.6 11.6 0 0 1-1.7-2 11.9 11.9 0 0 1-6.2-.4 13.3 13.3 0 0 1-2.1-1 11.6 11.6 0 0 1-6.8-.2c-5-1.7-8.2-6.2-7-10Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M98.5 496a10.7 10.7 0 0 0 1.8 1.3 11.3 11.3 0 0 0 .5 4.2 12 12 0 0 1-1-1.7 12.5 12.5 0 0 1-1.3-3.9ZM93 485.1a11.2 11.2 0 0 0 1.8 1.4 11.4 11.4 0 0 0 .5 4.2 12.7 12.7 0 0 1-2.3-5.6Zm12.5-4.1a11.1 11.1 0 0 0-.1-2.1 12.7 12.7 0 0 1 2.4 3.3 13 13 0 0 1 .8 1.8 11.4 11.4 0 0 0-3.1-3Zm34.7 65.5a11.7 11.7 0 0 0-1.5-1.7 12.4 12.4 0 0 0-.4-2 13.2 13.2 0 0 1 1.1 1.9 13 13 0 0 1 .8 1.8Zm-3.9-7.5a11.7 11.7 0 0 0-1.4-1.7 11.8 11.8 0 0 0-.5-2 12.7 12.7 0 0 1 2 3.7ZM104 506.8a10.1 10.1 0 0 0 1.7 1.3 10.9 10.9 0 0 0 .4 3.4 10 10 0 0 0-1 .3 13.3 13.3 0 0 0-2.2-1c-5.1-1.6-10.3.2-11.6 4a5.8 5.8 0 0 0-.1 3 7 7 0 0 1-1.7-6.6c1.3-3.8 6.5-5.6 11.6-4a12.8 12.8 0 0 1 2.1 1l1-.3a10.3 10.3 0 0 1-.2-1.1Zm38 43.5a12.8 12.8 0 0 1 1.2 1.9 13 13 0 0 1 .8 1.9 11.7 11.7 0 0 0-1.5-1.8 12.4 12.4 0 0 0-.4-2ZM111 492a11 11 0 0 0-.1-2.3 12.5 12.5 0 0 1 2.4 3.3 12.9 12.9 0 0 1 .7 1.9 11.4 11.4 0 0 0-3-3Zm7.9 44a12 12 0 0 0 .4 2.2 12.6 12.6 0 0 1-1.8-3.8 11.7 11.7 0 0 0 1.4 1.6Zm7.5 15a12.7 12.7 0 0 0 .5 2.2 12 12 0 0 1-1-1.7 12.9 12.9 0 0 1-.8-2 13 13 0 0 0 1.3 1.5Zm-3.7-7.5a12 12 0 0 0 .4 2.2 12.9 12.9 0 0 1-1-1.7 12.6 12.6 0 0 1-.8-2 11.7 11.7 0 0 0 1.4 1.5Zm-7.7-15a11.9 11.9 0 0 0 .6 2.2 12.4 12.4 0 0 1-1-1.7 12.2 12.2 0 0 1-.9-2 11.1 11.1 0 0 0 1.4 1.5Zm25-19c-4-1.3-8.5 1.8-10.1 7a12.6 12.6 0 0 0-.6 2.3 10.6 10.6 0 0 0-2.2 2.4 12.8 12.8 0 0 0-1-3l-.6-1a10.6 10.6 0 0 1 2-2 12.6 12.6 0 0 1 .5-2.3c1.7-5.1 6.2-8.3 10-7a7 7 0 0 1 4.4 5.2 6 6 0 0 0-2.5-1.6Zm-18.1 4a11.1 11.1 0 0 0 0-2.2 12.5 12.5 0 0 1 2.3 3.3 13 13 0 0 1 .8 1.9 11.3 11.3 0 0 0-3.1-3Zm-5.5-10.8a11.1 11.1 0 0 0 0-2.2 12.8 12.8 0 0 1 2.3 3.3 13 13 0 0 1 .8 1.9 11.4 11.4 0 0 0-3-3Zm13.9 55.8a11.9 11.9 0 0 0 .4 2.2 12.6 12.6 0 0 1-1-1.7 12.9 12.9 0 0 1-.8-2 13 13 0 0 0 1.3 1.5Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M82 461.3a12 12 0 0 1-4.1-4.7c-2.5-5-1.5-10.4 2.3-12.3s8.7.5 11.2 5.4a12 12 0 0 1 1.3 6.1 12.4 12.4 0 0 1 5.5 10.9 12 12 0 0 1 4.1 4.7 13.2 13.2 0 0 1 .8 1.8 10.6 10.6 0 0 0-5.4-4 6.2 6.2 0 0 1-7.9 4 10.5 10.5 0 0 0 0 6.8 13.2 13.2 0 0 1-1-1.7 12 12 0 0 1-1.3-6.2 12.4 12.4 0 0 1-5.5-10.8Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M21.9 392a36.8 36.8 0 0 1-4.4-2.5l16.3-12-19.2 10A36.3 36.3 0 0 1 1.1 362l32.5.3L1 357a36.3 36.3 0 1 1 71.8 9.2 36.7 36.7 0 0 1 6.7 4l-17 23.6 20.4-20.7a36.3 36.3 0 0 1 10.1 33A36.3 36.3 0 1 1 42.1 432 36.3 36.3 0 0 1 22 392Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M89.8 382.7a36.1 36.1 0 0 1 3.2 23.5A36.3 36.3 0 1 1 42.1 432c-7-3.4 46-53 47.7-49.3Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: "49", cy: "324.8", r: "5.4", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "17.5", cy: "328.2", r: "5.4", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "5.4", cy: "376.6", r: "5.4", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "21.8", cy: "400.8", r: "5.4", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "44.1", cy: "451", r: "5.4", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "44.1", cy: "451", r: "5.4", opacity: ".1" }), /* @__PURE__ */ React.createElement("circle", { cx: "93.8", cy: "394.1", r: "5.4", fill: colAccent }), /* @__PURE__ */ React.createElement("circle", { cx: "93.8", cy: "394.1", r: "5.4", opacity: ".1" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M99.6 482.7c3.6-1.8 4.7-7 2.6-11.6 0 .2.2.3.3.5 2.5 5 1.4 10.4-2.3 12.3s-8.8-.5-11.2-5.4l-.3-.6c2.5 4.5 7.3 6.6 10.9 4.8Zm5.4 10.5c3.5-1.8 4.6-6.9 2.5-11.6l.3.6c2.5 4.9 1.5 10.3-2.3 12.2s-8.7-.5-11.2-5.4l-.3-.6c2.6 4.5 7.3 6.6 11 4.8Zm5.2 10.6c3.6-1.9 4.7-7 2.6-11.7l.3.6c2.5 4.9 1.5 10.4-2.3 12.3s-8.7-.6-11.2-5.5l-.3-.6c2.6 4.5 7.4 6.7 11 4.9Zm5.3 10.5c3.6-1.8 4.7-7 2.6-11.7l.3.6c2.5 4.9 1.5 10.4-2.2 12.3s-8.8-.6-11.3-5.5l-.3-.6c2.6 4.5 7.4 6.7 11 4.9Zm5.4 10.5c3.5-1.8 4.6-7 2.5-11.7l.4.6c2.4 5 1.4 10.4-2.3 12.3s-8.8-.6-11.3-5.4l-.3-.6c2.6 4.4 7.4 6.6 11 4.8Zm5.3 10.5c3.6-1.8 4.6-7 2.6-11.7l.3.6c2.4 5 1.4 10.4-2.3 12.3s-8.8-.5-11.2-5.4l-.3-.6c2.5 4.4 7.3 6.6 10.9 4.8Zm5.3 10.5c3.6-1.8 4.7-7 2.6-11.6l.3.5c2.5 5 1.4 10.4-2.3 12.3s-8.8-.5-11.2-5.4l-.3-.6c2.6 4.5 7.3 6.6 11 4.8Zm5.3 10.5c3.6-1.8 4.7-6.9 2.6-11.6l.3.6c2.5 4.9 1.5 10.4-2.3 12.2s-8.7-.5-11.2-5.4l-.3-.6c2.6 4.5 7.3 6.6 11 4.8Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M140.3 563.2c3.6-1.8 4.7-6.9 2.6-11.6l.3.6c2.5 4.9 1.5 10.4-2.2 12.2s-8.8-.5-11.3-5.4l-.3-.6c2.6 4.5 7.3 6.6 11 4.8Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M44.2 516.4a18.6 18.6 0 0 1-1-4.9 2.7 2.7 0 1 1 .4-5.3 18.8 18.8 0 0 1 10-12.8 2.7 2.7 0 1 1 4.7-2.4 2.4 2.4 0 0 1 .3.7 19 19 0 0 1 16.5 5 18.7 18.7 0 0 1 5-.1l2.2 9.9v-9.6a18.9 18.9 0 1 1-10 36.3 2.8 2.8 0 0 1-1.2 1 2.7 2.7 0 0 1-3.7-3.4 18.8 18.8 0 0 1-2.4-2 18.9 18.9 0 0 1-19.8-10l10.2-1.7Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M59.9 521.3c3.7-5 6-10.8 8.7-16.5a66.7 66.7 0 0 1 3.5-6.7l2-2.3 1 .9a18.7 18.7 0 0 1 5-.2l2.2 10v-9.6a18.9 18.9 0 1 1-10 36.3 2.8 2.8 0 0 1-1.2 1 2.7 2.7 0 0 1-3.7-3.4 18.8 18.8 0 0 1-2.4-2 19 19 0 0 1-11.3-1.7 26.6 26.6 0 0 0 6.2-5.8Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M126.3 500a2.7 2.7 0 0 1 1.1-3.6 2.6 2.6 0 0 1 1.3-.3 18.9 18.9 0 0 1 5.9-10.5 18.7 18.7 0 0 1-.6-5.9l9.9-1.7-9.6-.6a18.6 18.6 0 0 1 .7-2.6 2.6 2.6 0 0 1-.9-1 2.7 2.7 0 0 1 3.3-3.8 18.6 18.6 0 0 1 7-5.9 18.8 18.8 0 0 1 26.7 21.5 2.7 2.7 0 0 1 .1 4.9 2.7 2.7 0 0 1-2.2 0 18.7 18.7 0 0 1-3.6 4.4 18.9 18.9 0 0 1-.8 12l-13.3-3.5 11.9 6.3a18.9 18.9 0 0 1-32.8-1.6 19.1 19.1 0 0 1-2-6.6 2.7 2.7 0 0 1-2.1-1.5Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M126.3 500a2.7 2.7 0 0 1 1.1-3.6 2.6 2.6 0 0 1 1.3-.3 18.9 18.9 0 0 1 5.9-10.5l-.3-1a7.3 7.3 0 0 1 1 1c1.8 2 2.8 4.5 4.5 6.5a13 13 0 0 0 8.3 3.9 31.5 31.5 0 0 0 9.4-.8 27.4 27.4 0 0 1 7.7-.8h.7l-.4.5a18.9 18.9 0 0 1-.9 12l-13.3-3.5 11.9 6.3a18.9 18.9 0 0 1-32.8-1.6 19.1 19.1 0 0 1-2-6.6 2.7 2.7 0 0 1-2.1-1.5Z",
      opacity: ".1"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M346.4 52a20.2 20.2 0 0 0-11.8 1.2 17.3 17.3 0 0 1-14 0 19.8 19.8 0 0 0-16.7.3 10.3 10.3 0 0 1-4.7 1.2c-6.8 0-12.3-6.8-13.5-15.7a13 13 0 0 0 3.4-3.6C293 29 299 25 305.9 25s13 4 16.9 10.3a13 13 0 0 0 11.1 6.1h.2c5.3 0 10 4.3 12.3 10.5Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "m366.8 24-10.9 6.8 6.6-12a10.7 10.7 0 0 0-6.6-2.3h-.1a12.9 12.9 0 0 1-2.3-.2l-3.7 2.3 1.6-2.8a13.2 13.2 0 0 1-6.4-4.9l-6.6 4.1 4.1-7.5A19 19 0 0 0 327.8 0c-6.9 0-13 4-17 10.4a12.6 12.6 0 0 1-11.1 6h-.3c-7.6 0-13.7 8.6-13.7 19.2s6 19.1 13.7 19.1a10.3 10.3 0 0 0 4.7-1.2 19.7 19.7 0 0 1 16.6-.3 17.4 17.4 0 0 0 14.1 0 19.8 19.8 0 0 1 16.4.4 10.3 10.3 0 0 0 4.8 1.1c7.5 0 13.7-8.6 13.7-19.1a24.4 24.4 0 0 0-3-11.7ZM120.3 190.4a29 29 0 0 0-16.7 1.9 24.7 24.7 0 0 1-20.2 0 28.2 28.2 0 0 0-23.6.4 14.8 14.8 0 0 1-6.9 1.7c-9.6 0-17.6-9.7-19.2-22.4a18.4 18.4 0 0 0 4.8-5.2c5.6-9 14.3-15 24.1-15s18.4 5.8 24 14.8a18.5 18.5 0 0 0 16 8.8h.3c7.6 0 14.2 6.1 17.4 15Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "m149.5 150.4-15.5 9.8 9.4-17a15.3 15.3 0 0 0-9.3-3.4h-.3a18.2 18.2 0 0 1-3.2-.3l-5.3 3.4 2.3-4a18.7 18.7 0 0 1-9.2-7l-9.4 6 6-11a27.6 27.6 0 0 0-21.2-10.7c-9.8 0-18.5 5.9-24.1 15a18 18 0 0 1-16 8.5h-.5c-10.9 0-19.6 12.3-19.6 27.4s8.7 27.4 19.6 27.4a14.6 14.6 0 0 0 6.8-1.7 28.2 28.2 0 0 1 23.7-.5 24.7 24.7 0 0 0 20.1 0 28.3 28.3 0 0 1 23.5.5 14.7 14.7 0 0 0 6.7 1.7c10.8 0 19.6-12.3 19.6-27.4a34.8 34.8 0 0 0-4-16.7ZM748 91a20.2 20.2 0 0 1 11.7 1.2 17.3 17.3 0 0 0 14.1 0 19.8 19.8 0 0 1 16.6.3 10.3 10.3 0 0 0 4.8 1.2c6.7 0 12.3-6.8 13.4-15.7a13 13 0 0 1-3.3-3.6c-4-6.4-10-10.5-17-10.5s-12.8 4-16.8 10.3a13 13 0 0 1-11.1 6.2h-.2c-5.3 0-10 4.3-12.2 10.5Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "m727.5 63 10.9 6.8-6.6-12a10.8 10.8 0 0 1 6.5-2.4h.2a13 13 0 0 0 2.3-.1l3.6 2.3-1.6-2.9a13.2 13.2 0 0 0 6.6-4.8l6.5 4.2-4.1-7.6c3.8-4.6 9-7.5 14.7-7.5 6.9 0 13 4.1 17 10.5a12.6 12.6 0 0 0 11.1 6h.4c7.5 0 13.7 8.5 13.7 19.1s-6.2 19.2-13.7 19.2a10.3 10.3 0 0 1-4.8-1.2 19.7 19.7 0 0 0-16.6-.3 17.4 17.4 0 0 1-14 0 19.8 19.8 0 0 0-16.5.3 10.3 10.3 0 0 1-4.7 1.2c-7.6 0-13.7-8.6-13.7-19.2a24.4 24.4 0 0 1 2.8-11.7Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "ellipse",
    {
      cx: "615.6",
      cy: "756.9",
      fill: colAccent,
      opacity: ".1",
      rx: "115",
      ry: "20"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#d0d2d5",
      d: "m555.4 661.9-178.1-2.3.5-4.6 8.6-75.4h156.5l11.5 75.4.9 5.7.1 1.2z"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M555.3 660.7h-88.9l-89.1-1.1.5-4.6h176.6l.9 5.7z", opacity: ".1" }), /* @__PURE__ */ React.createElement("path", { fill: "#d0d2d5", d: "M347.6 656.2H584v5.7H347.6z" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M809.6 126.8a14.9 14.9 0 0 0-14.8-14.9H134.5a14.9 14.9 0 0 0-14.8 15V527h689.9Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#d0d2d5",
      d: "M119.7 523.1V570a14.8 14.8 0 0 0 14.8 14.8h660.3a14.8 14.8 0 0 0 14.8-14.8v-47Z"
    }
  ), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M148.2 137h636.2v359.8H148.2z" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M468 567a15.4 15.4 0 0 0 12.2-5.9 16 16 0 0 0 1.2-1.8l-8.5-1.4h9.2a15.4 15.4 0 0 0 .3-12.1L470 552l11.3-8.3a15.4 15.4 0 1 0-25.5 17.3 15.4 15.4 0 0 0 12.2 5.9Z"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "m483.5 584.8 71.1 71.4-10.9-71.4h-60.2z", opacity: ".1" }), /* @__PURE__ */ React.createElement("path", { fill: "#444053", d: "M147.7 137.1h636.9v21H147.7z", opacity: ".1" }), /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "191.9",
      height: "12.8",
      x: "368.9",
      y: "140.7",
      fill: colAccent,
      opacity: ".3",
      rx: ".6"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M555 148.4h-.4l-.2-.1a3.9 3.9 0 0 0 1-2.5 3.8 3.8 0 1 0-3.8 3.8 3.9 3.9 0 0 0 2.5-1l.1.2v.5l3 3 .8-1Zm-3.4 0a2.6 2.6 0 1 1 2.6-2.6 2.6 2.6 0 0 1-2.6 2.6Z"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: "159.2", cy: "147.6", r: "3.9", fill: "#fa5959", opacity: ".8" }), /* @__PURE__ */ React.createElement("circle", { cx: "169.8", cy: "147.6", r: "3.9", fill: "#fed253", opacity: ".8" }), /* @__PURE__ */ React.createElement("circle", { cx: "180.4", cy: "147.6", r: "3.9", fill: "#8ccf4d", opacity: ".8" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M500 291.4c-8.7-11.6-21.3-19-35.4-19s-26.7 7.4-35.5 19a38.4 38.4 0 0 0 8.4 12.7 38.3 38.3 0 0 0 62.6-12.7Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M424.5 298.2a9.2 9.2 0 0 1-1.7-1 7 7 0 0 1-2-2.5 7.2 7.2 0 1 0-11.7 1.7 8 8 0 0 0 1.7 1.4 5 5 0 0 1 2 2 14.4 14.4 0 0 0 3.2 4.3 29 29 0 0 0 4.6 3.2 66.3 66.3 0 0 0-3.8 19.6 27 27 0 0 0-7.6 1.2 12.3 12.3 0 0 0-3.5 1.8 8.5 8.5 0 0 0-.9 0 7.2 7.2 0 1 0 6.8 9.7 4.6 4.6 0 0 1 3.7-3 16.8 16.8 0 0 1 1.8-.2 64.4 64.4 0 0 0 8.6 26.7 21 21 0 0 0-8 10.9 3 3 0 0 0-.6.4 6.8 6.8 0 0 0-.8.8 7.2 7.2 0 1 0 12 2.3 4.7 4.7 0 0 1 1.2-5l1.7-1.5a42 42 0 0 0 29.8 16.2V323a44.4 44.4 0 0 1-36.5-24.8Zm99.9 31.7a8 8 0 0 0-1 0 13.6 13.6 0 0 0-3.4-1.7 26.9 26.9 0 0 0-7.7-1.2 67.8 67.8 0 0 0-3.7-19.6 29 29 0 0 0 4.5-3.2 15.6 15.6 0 0 0 3.5-4.5 4.2 4.2 0 0 1 1.8-1.8 7.2 7.2 0 1 0-10-3.2 6.8 6.8 0 0 1-2 2.5 18.9 18.9 0 0 1-1.7 1.3 44 44 0 0 1-36.5 24.5v64.3c12-.7 21.7-6.8 29.8-16.2l1.6 1.3a4.9 4.9 0 0 1 1.3 5.3 7.2 7.2 0 1 0 12-2.3 6.8 6.8 0 0 0-.8-.8l-.6-.4c-1-4-3.7-7.6-8-10.9a64.4 64.4 0 0 0 8.6-26.7 15.9 15.9 0 0 1 1.7.1 4.8 4.8 0 0 1 3.9 3 7.2 7.2 0 0 0 13.8-2.1 7.3 7.3 0 0 0-7.1-7.7Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "url(#a)",
      d: "M769.6 802.3a9.6 9.6 0 0 0-2.1-2.4c-4.4-4.1-6.4-10.2-7.5-16.1s-1.4-12-3.1-17.8a58.7 58.7 0 0 0-3.5-8.7c-1-2.1-2.3-6.3-4.1-7.8a2.7 2.7 0 0 0-1.3-.6 14.8 14.8 0 0 0-3.6-4.9c-2.9-2.6-6.4-4.6-8.3-8a18 18 0 0 0-1.9-3.3c-1.3-1.4-3.3-2-4.5-3.5-1.6-1.9-1.2-4.7-1-7.2s0-5.4-2.2-6.7c-1.2-.8-2.9-.7-4.2-1.4-2-1-2.8-3.5-2.8-5.8s.8-4.4 1-6.7c.5-7.1-4.2-14.2-2.4-21.2.7-2.6 2.3-4.9 3.4-7.3a15.4 15.4 0 0 0 1-2.6 35.7 35.7 0 0 0 9.8 2.4c-5.5-12.4-4.1-26.7-6.7-40l.3-.5a20.8 20.8 0 0 0 4.3-11.8c0-5-2.3-9.6-3.4-14.4-.9-4.1-.8-8.4-2-12.5a37.6 37.6 0 0 0-3.1-7.2l-4-6.8-3.8-12.8c-1.8-5.9-3.7-12-7.2-17-1.3-2-1.6-5.8-3.6-7a8.8 8.8 0 0 0-5.2-.8c-2.8-1.6-5.2-3.9-5.6-7a6.7 6.7 0 0 1 .2-2h.4c4.4-.3 6.6-4.2 8.9-7.6 3.7-5.5 2.3-13 0-19.2a13 13 0 0 0-3-5.3c-3.2-3-8.3-2.3-12.5-3.8-1.3-.5-2.6-1.2-4-1.5-2.8-.7-5.7.2-8.2 1.5s-4.9 2.9-7.5 3.9-6 1.8-6.6 4.5a5 5 0 0 0 .2 2.7 10.2 10.2 0 0 0 3.1 4.5 17.8 17.8 0 0 0 10.9 24.8 51 51 0 0 1 2.1 3.7c1.2 2.3 2.2 5 1.8 7.3a22.4 22.4 0 0 0-2 2.5c-3 4-4.5 8.7-6 13.3a141.7 141.7 0 0 0-4.9 18.3c-2.4 5.2-5.4 10.2-7.2 15.6a35.2 35.2 0 0 1-9.3-1.3l-8.5-1.9c-3-.6-6-1.4-8.3-3.3-1.2-1-2.1-2.3-3.4-3.3s-3.7-2.2-5-1.3a4 4 0 0 0-.8.5c-1.2-2.5-2.4-5-3.8-7.4-2.1-3.4-5.2-6.6-9-7.2a9.2 9.2 0 0 0-6.9 1.6c-2.2 1.6-3.7 5-2 7.3a13.3 13.3 0 0 0 1.4 1.4 29.2 29.2 0 0 1 3.1 4.3 22 22 0 0 0 13.5 8.7l-.3 1c-.8 2.1-2.3 4.6-1.9 6.8l37.5 12.8a23.1 23.1 0 0 0 7.6 1.7 12.2 12.2 0 0 0 3-.4v2c.1 13.2-2 26.3-2.4 39.5 0 2.4 0 5 1.5 6.9 1.7 2 4.8 2.4 7.4 2l1.8-.5a69.3 69.3 0 0 1 2 10.1l2.4 17.9a27.1 27.1 0 0 1 .4 5.5c-.3 4.2-2.5 8-4 11.8s-2.6 8.5-.5 12.2c.6 1 1.6 2 2.1 3.2a13.1 13.1 0 0 1 1 5.7l.5 16.2a1.8 1.8 0 0 0-1.3.2c-2 1.6-1.8 9.3-2 11.7-.1 4 0 8.1-.2 12.1a72.2 72.2 0 0 1-2.6 16.1 10.3 10.3 0 0 1-2.3 4.6 9.7 9.7 0 0 1-4 2.2 46.5 46.5 0 0 1-15.5 2c-2 0-4.3-.2-6.2.6s-3.6 3-2.9 5c.6 1.7 2.5 2.5 4.2 3.1a65.5 65.5 0 0 1 11 5 29.7 29.7 0 0 0 4.2 2.5 22 22 0 0 0 4.4 1l17.7 3.1c3.6.6 8 1 10.3-2 1.3-1.6 1.5-3.8 1.4-5.9-.1-4-.9-8-.4-12a37.1 37.1 0 0 1 1.9-7l5.3-15.7a84.3 84.3 0 0 0 4.3-16c.2-2 .2-4.4-1.3-5.6a3.5 3.5 0 0 0-1.3-.7c-.1-4.8-.7-9.7-.5-14.5l.3-3.6a17.6 17.6 0 0 1 2.5 3c1.7 2.6 2.3 6.2 5 8 2.2 1.5 5.5 1.4 7 3.6a10.3 10.3 0 0 1 1.1 2.7 19.3 19.3 0 0 0 4 6.3 32 32 0 0 0 2.5 6.4l4.4 9.3a108.6 108.6 0 0 0 5 9.8 27.6 27.6 0 0 1 3.4 6.4c1.4 5-1 10.4-4.6 14s-8.4 5.7-13.1 7.7a3.7 3.7 0 0 0-1.4.8 2.6 2.6 0 0 0-.6 1.7c0 2.3 1.9 4.3 4 5a15.3 15.3 0 0 0 7 .3c12.7-1.6 25.4-4.7 36.7-10.9a13 13 0 0 0 4.4-3.4 5.1 5.1 0 0 0 .8-5.2Z",
      transform: "translate(-88.7 -57)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colClothing,
      d: "M627 521q3.2 4.9 6 10a37 37 0 0 1 3.2 7.2c1.1 4 1 8.3 2 12.3 1 4.8 3.3 9.4 3.3 14.3a20.6 20.6 0 0 1-4.2 11.8 55.8 55.8 0 0 1-8.8 9.1 187.6 187.6 0 0 1-12.5-61.2c-.1-2.9-.1-5.9 1-8.6.6-1.7 3.7-6.4 5.7-4.5.7.6 1 3.7 1.4 4.7a36.1 36.1 0 0 0 2.9 4.9Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M627 521q3.2 4.9 6 10a37 37 0 0 1 3.2 7.2c1.1 4 1 8.3 2 12.3 1 4.8 3.3 9.4 3.3 14.3a20.6 20.6 0 0 1-4.2 11.8 55.8 55.8 0 0 1-8.8 9.1 187.6 187.6 0 0 1-12.5-61.2c-.1-2.9-.1-5.9 1-8.6.6-1.7 3.7-6.4 5.7-4.5.7.6 1 3.7 1.4 4.7a36.1 36.1 0 0 0 2.9 4.9Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#d0d2d5",
      d: "M363.4 384.5c-8 8-9 11.4-13.7 13s-21.8 10.4-16.4 20.2l14.4 9.6.4.2 2.2 6.7-21.8 38.9s-36-16.5-39.5 7.8-1.3 31-2.3 44 .3 16.8-2.8 16.8-4.4-8.5-4.4-8.5l-.6-1.1c-4.7-9.8-36.7-81.7 14.5-131.1 0 0 23.7-1.6 29.5-28.8 3.9-18.8 17.7-17.1 26.8-13.3a30.4 30.4 0 0 1 8.3 4.8 40.5 40.5 0 0 1 5.8 7c2.7 4.1 4 9.3-.4 13.8Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "m348.1 427.5 2.2 6.7-21.8 38.9s-36-16.5-39.5 7.8-1.3 31-2.3 44 .3 16.8-2.8 16.8-4.4-8.5-4.4-8.5l-.6-1.2c-1.6-12.1-9.7-83.2 19.6-79.5 0 0 23.7 11.1 27.5 6.7 3-3.5 16.3-23.6 21.7-31.9Zm15.8-56.9-14.5 16.5s-16.8 22.4-20.2 21.4a16.2 16.2 0 0 0-3.2-.3 6.2 6.2 0 0 1-4-10.4c5.7-6 16.3-17.4 17-20s7.3-13.5 10.7-19a30.4 30.4 0 0 1 8.2 4.9 40.5 40.5 0 0 1 6 7Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colHammer,
      d: "M772.4 606.7c-2.4 5-15 23.3-20.5 31.3l-2.5 3.8s-1 6.7-17.4-1.6-401.5-170.7-401.5-170.7l-2.6-7.8 19-28.5 422 163.1s6.7 4.1 3.5 10.4Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "m752 638-2.6 3.8s-1 6.7-17.4-1.6-401.5-170.7-401.5-170.7l-2.6-7.8Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fbbebe",
      d: "M519.6 532c-3.9-.7-8.2-.4-11.3 2.1a9.3 9.3 0 0 0-3.2 6.2c-.3 2.8 1.4 6 4.1 6.3a13.2 13.2 0 0 0 2-.2 29.9 29.9 0 0 1 5.3.5 21.4 21.4 0 0 0 18.2-7.4c2.4-3-.8-4.3-3.6-4.9-3.8-.8-7.6-2-11.5-2.7Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "m586.5 622.2 2.5 17.6a26.8 26.8 0 0 1 .4 5.5c-.3 4.2-2.5 8-4.1 11.8s-2.6 8.4-.5 12c.7 1 1.6 2 2.2 3.2a13 13 0 0 1 1 5.6l.7 25a157.3 157.3 0 0 0 23.1-.1 1.3 1.3 0 0 0 .9-.3 1.4 1.4 0 0 0 .3-.9c.3-5.8-.7-11.7-.4-17.6l.5-6.4c.1-8.7-4.2-17.2-2.9-25.8a57 57 0 0 1 1.6-6.5 143 143 0 0 0 2.3-46.2 1 1 0 0 0-.2-.7 1 1 0 0 0-.5-.3 28.4 28.4 0 0 0-25.8 4.9c-1 .9-3.8 1.7-4.5 2.8-1 1.4.3 2.9.8 4.5a56.9 56.9 0 0 1 2.6 12Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "m586.5 622.2 2.5 17.6a26.8 26.8 0 0 1 .4 5.5c-.3 4.2-2.5 8-4.1 11.8s-2.6 8.4-.5 12c.7 1 1.6 2 2.2 3.2a13 13 0 0 1 1 5.6l.7 25a157.3 157.3 0 0 0 23.1-.1 1.3 1.3 0 0 0 .9-.3 1.4 1.4 0 0 0 .3-.9c.3-5.8-.7-11.7-.4-17.6l.5-6.4c.1-8.7-4.2-17.2-2.9-25.8a57 57 0 0 1 1.6-6.5 143 143 0 0 0 2.3-46.2 1 1 0 0 0-.2-.7 1 1 0 0 0-.5-.3 28.4 28.4 0 0 0-25.8 4.9c-1 .9-3.8 1.7-4.5 2.8-1 1.4.3 2.9.8 4.5a56.9 56.9 0 0 1 2.6 12Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colDark,
      d: "M632.9 617c-1.2 2.3-2.7 4.6-3.4 7.2-1.9 6.9 2.8 14 2.3 21-.2 2.3-.9 4.5-1 6.7s.8 4.7 2.8 5.7c1.3.7 3 .6 4.3 1.4 2 1.3 2.3 4.2 2.1 6.7s-.6 5.2 1 7.1c1.2 1.5 3.2 2.1 4.5 3.5a17.2 17.2 0 0 1 2 3.3c1.8 3.3 5.3 5.4 8.2 8s5.3 6.4 4 10c-1 2.7-3.6 4.4-6.1 5.6a65 65 0 0 1-14.6 5.2 3.5 3.5 0 0 1-1.7 0 3.6 3.6 0 0 1-1.4-1c-3-2.8-6-5.9-7.4-9.8a10 10 0 0 0-1.1-2.6c-1.6-2.2-4.9-2.1-7-3.7-2.7-1.7-3.3-5.2-5-7.9s-4.2-4.2-6-6.5c-3-4-3.8-9.1-6-13.5-1-2-2.1-3.7-2.9-5.6a30.6 30.6 0 0 1-1.3-7.3c-1.4-11.7-5-23.4-2.8-35 .5-2.5 1.3-5 1.6-7.6.6-4.5-.3-9.2.4-13.7a3.8 3.8 0 0 1 1.5-2.9 4 4 0 0 1 1.7-.3 117.3 117.3 0 0 1 17.8.4c3 .2 6.3.9 8.1 3.3 1.6 2.1 1.5 5 2 7.5.6 3.1 2.2 4.8 3.8 7.3s.8 4.9-.4 7.4Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colClothing,
      d: "M609.8 698.2c1.6 0 3.4-.1 4.6.9 1.5 1.2 1.5 3.5 1.3 5.5a82.4 82.4 0 0 1-4.3 16l-5.3 15.6a36.6 36.6 0 0 0-1.9 6.8c-.5 4 .3 8 .4 12 0 2-.1 4.3-1.4 5.9-2.3 2.9-6.7 2.6-10.3 2l-17.7-3a21 21 0 0 1-4.4-1 30.6 30.6 0 0 1-4.2-2.5 65.4 65.4 0 0 0-11-5c-1.7-.6-3.6-1.4-4.2-3-.7-2 1-4.3 2.9-5s4.1-.7 6.3-.6a47 47 0 0 0 15.3-2 9.7 9.7 0 0 0 4.1-2.2 10 10 0 0 0 2.4-4.7 70.2 70.2 0 0 0 2.6-16l.3-12c0-2.4-.2-10 2-11.6 1.5-1.2 8 2.1 10.2 2.6a50 50 0 0 0 12.3 1.3Zm58.4 11.1c1.7 5.7 2 11.8 3 17.7s3.2 11.9 7.5 16a9.9 9.9 0 0 1 2.2 2.4 5 5 0 0 1-.7 5.2 13.1 13.1 0 0 1-4.4 3.4c-11.3 6.1-24 9.2-36.8 10.8a15.5 15.5 0 0 1-6.8-.3c-2.2-.7-4.2-2.7-4.1-5a2.5 2.5 0 0 1 .6-1.7 3.7 3.7 0 0 1 1.3-.8c4.7-2 9.5-4 13.2-7.6s6-9 4.5-13.9a27.4 27.4 0 0 0-3.4-6.4 108.3 108.3 0 0 1-5-9.7l-4.3-9.2a24.2 24.2 0 0 1-2.9-8.5 40.6 40.6 0 0 0 16.3-2.6 25.5 25.5 0 0 0 6.6-4c1.7-1.4 3.3-4 5.6-2.2 1.8 1.5 3 5.7 4 7.8a57 57 0 0 1 3.6 8.6Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fbbebe",
      d: "M603.7 480.1c.4 3.8 4.1 6.4 7.7 7.9l-22.5 7.2c1.5-2.8.3-6.2-1.1-9a51 51 0 0 0-4-6.4c-.3-.4-.5-.8-.3-1.1a1.1 1.1 0 0 1 .6-.5c4.6-2 9.4-4.2 14.4-5 1.5-.1 4.2-.7 5.3.8s-.3 4.3-.1 6.1Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M603.7 480.1c.4 3.8 4.1 6.4 7.7 7.9l-22.5 7.2c1.5-2.8.3-6.2-1.1-9a51 51 0 0 0-4-6.4c-.3-.4-.5-.8-.3-1.1a1.1 1.1 0 0 1 .6-.5c4.6-2 9.4-4.2 14.4-5 1.5-.1 4.2-.7 5.3.8s-.3 4.3-.1 6.1Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: "590.6", cy: "465.6", r: "17.6", fill: "#fbbebe" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colClothing,
      d: "M575.4 610.6c1.7 2 4.7 2.4 7.3 2 6.2-1 11.2-5.5 17.2-7.2 7.4-2 15.2.6 22.2 3.7s13.9 7 21.5 7.6c-7-15.4-3-33.9-9.6-49.3-1.6-3.8-3.8-7.5-4.2-11.6-.4-5 2.1-10 2.5-15 .4-4.5-1-9-2.3-13.3l-4.8-15.9a60.9 60.9 0 0 0-7.2-17c-1.2-1.8-1.6-5.6-3.6-6.8-4.3-2.4-10.8.7-15.4.8s-8.9 3.5-11.6 7.2c-2.9 4-4.5 8.7-6 13.3a126.2 126.2 0 0 0-5.3 21.2l-.4 3.3c-1 10.3.5 20.6.5 31 .1 13-2 26-2.4 39.2 0 2.4 0 5 1.6 6.8Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M576.3 564.5c3.4-.9 6.5-3 9.2-5.5a38.7 38.7 0 0 0 6.2-7 49.9 49.9 0 0 0 5.3-11 129.4 129.4 0 0 0 7-32.4c.2-3 .3-6.2-1.5-8.6a7.2 7.2 0 0 0-8.8-2 14.5 14.5 0 0 0-5.3 5.6 73.7 73.7 0 0 0-7.4 13.8l-2.2 6.7a61 61 0 0 1-2.7 6.3l-.4 3.2c-1 10.3.5 20.6.6 31Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colClothing,
      d: "M602.5 498.1c1.7 2.4 1.7 5.6 1.4 8.6a129.2 129.2 0 0 1-7 32.3 49.4 49.4 0 0 1-5.3 11.1 39 39 0 0 1-6.1 7c-3.4 3.1-7.6 5.9-12.2 6a23.2 23.2 0 0 1-7.5-1.7l-37.6-12.8c-.4-2.1 1.1-4.6 1.9-6.7l2-6c.5-1.6 1.2-3.3 2.7-4.2s3.8.3 5 1.3l3.5 3.3c2.3 2 5.3 2.6 8.3 3.3l8.4 1.9a35.2 35.2 0 0 0 9.4 1.2c2.3-7.1 6.8-13.5 9.3-20.6l2.2-6.6c1.8-5 4.6-9.4 7.5-13.8 1.4-2.2 2.9-4.6 5.3-5.7a7.2 7.2 0 0 1 8.8 2.1Zm-6.3-28.5a8.9 8.9 0 0 0-1-3.3 2.8 2.8 0 0 0-3-1.4c-1.8.6-2.4 3.3-4.2 3.4-1.2 0-2.1-1.2-2.5-2.4s-.6-2.5-1.6-3.3a5.7 5.7 0 0 0-2.1-1c-4.3-1.4-8.7-3.9-10.1-8.1a4.8 4.8 0 0 1-.3-2.7c.7-2.7 4-3.5 6.6-4.5s5-2.6 7.5-3.9 5.4-2.1 8.1-1.5a42.5 42.5 0 0 1 4.1 1.5c4.2 1.5 9.2.8 12.5 3.8a12.8 12.8 0 0 1 3 5.2c2.2 6.2 3.6 13.6 0 19-2.4 3.5-4.6 7.3-9 7.7-5.1.4-7.1-4.2-8-8.5Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M588.4 463.8c-.4-1.2-.6-2.5-1.5-3.4a5.7 5.7 0 0 0-2.2-1c-4.3-1.3-8.7-3.8-10-8a5 5 0 0 1-.3-2.8 3.4 3.4 0 0 1 .5-1.1c-1.6.7-3 1.6-3.4 3.3a4.8 4.8 0 0 0 .2 2.7c1.4 4.2 5.8 6.7 10.1 8a5.7 5.7 0 0 1 2.2 1c1 .9 1.1 2.2 1.5 3.4s1.3 2.5 2.5 2.4 1.9-1.2 2.7-2.1c-1.1-.2-2-1.3-2.3-2.4Zm18.7 12.2c-5.1.4-7.1-4.2-8-8.6a8.7 8.7 0 0 0-1-3.3 2.8 2.8 0 0 0-3-1.3 5.3 5.3 0 0 0-2.2 2 3 3 0 0 1 2.3 1.4 8.9 8.9 0 0 1 1 3.3c.9 4.3 2.9 9 8 8.5a8.3 8.3 0 0 0 5.3-2.7 7.5 7.5 0 0 1-2.4.7Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement("ellipse", { cx: "813.1", cy: "655.8", fill: colAccent, rx: "32.3", ry: "6.2" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "653.1", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "647.1", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "641.1", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "635.1", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "629.1", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "623.1", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "812.6", cy: "617", fill: colDark, rx: "3.8", ry: "4.9" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M826.6 576a18.2 18.2 0 0 0 1.4-2.2l-9.8-1.6 10.6.1a18.1 18.1 0 0 0 .4-14.3l-14.3 7.5 13.2-9.7a18 18 0 1 0-29.8 20.1 18 18 0 0 0-2 3.3l12.8 6.7-13.7-4.6a18 18 0 0 0 3 16.9 18 18 0 1 0 28.3 0 18 18 0 0 0 0-22.3Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M794.5 587a18 18 0 0 0 3.9 11.1 18 18 0 1 0 28.3 0c2.4-3-32.2-13.1-32.2-11Z",
      opacity: ".1"
    }
  ), /* @__PURE__ */ React.createElement("ellipse", { cx: "148.4", cy: "776.9", fill: colAccent, rx: "46.5", ry: "8.9" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "773.1", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "764.4", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "755.8", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "747.1", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "738.4", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "729.8", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "147.6", cy: "721.1", fill: colDark, rx: "5.4", ry: "7.1" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: colAccent,
      d: "M167.9 661.8a27.2 27.2 0 0 0 2-3l-14.2-2.3 15.4.1a26 26 0 0 0 .5-20.5l-20.7 10.7 19-14a26 26 0 1 0-42.8 29 25.8 25.8 0 0 0-3 4.7l18.5 9.6-19.7-6.6A26 26 0 0 0 127 694a26 26 0 1 0 40.8 0 26 26 0 0 0 0-32Z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M121.6 678a25.9 25.9 0 0 0 5.5 16 26 26 0 1 0 40.8 0c3.4-4.5-46.3-19-46.3-16Z",
      opacity: ".1"
    }
  ));
}
const DEFAULT_TITLE = "Hoppla! Ein unerwarteter Fehler ist aufgetreten...";
const DEFAULT_DESCRIPTION = "Sollte der Fehler weiterhin auftreten, wenden Sie sich bitte an die Administrator:innen";
const DEFAULT_HOME_PAGE_LINK = "/";
const BACK_TO_APP_TITLE = "Zur Anwendung zurückkehren. Bitte beachten Sie, dass die Anwendung nicht mehr voll funktionsfähig sein kann. Laden Sie in dem Fall die Seite neu";
function extractMessage(err) {
  if (typeof err === "string") {
    return err;
  }
  const errMessage = err && err.message;
  if (typeof errMessage === "string") {
    return errMessage;
  }
  return "Ein unbekannter Fehler ist aufgetreten";
}
const reloadPage = (e) => {
  e.preventDefault();
  window.location.reload();
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleGlobalError", (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();
      const { message, error } = e;
      const stack = error instanceof Error ? error.stack ?? "" : "";
      this.setState({ hasError: true, message, stack });
    });
    __publicField(this, "handleClose", () => {
      this.setState({ hasError: false });
    });
    this.state = {
      hasError: false,
      message: "",
      stack: ""
    };
  }
  componentDidMount() {
    window.addEventListener("error", this.handleGlobalError);
  }
  componentDidCatch(err, info) {
    this.setState({
      hasError: true,
      stack: info.componentStack,
      message: extractMessage(err)
    });
  }
  componentWillUnmount() {
    window.removeEventListener("error", this.handleGlobalError);
  }
  render() {
    const { hasError, message, stack } = this.state;
    const {
      children,
      title = DEFAULT_TITLE,
      description = DEFAULT_DESCRIPTION,
      homePageLink = DEFAULT_HOME_PAGE_LINK,
      className
    } = this.props;
    return hasError ? /* @__PURE__ */ React.createElement("div", { className: classNames("error-boundary__wrapper", className) }, /* @__PURE__ */ React.createElement(
      "nav",
      {
        className: "error-boundary__navigation",
        "aria-label": "Navigation bei Fehlerfall"
      },
      /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "error-boundary__link",
          title: "Seite neu laden",
          href: "#",
          onClick: reloadPage
        },
        /* @__PURE__ */ React.createElement(
          "svg",
          {
            fill: "currentColor",
            className: "error-boundary__icon",
            focusable: "false",
            "aria-hidden": "true",
            viewBox: "0 0 24 24"
          },
          /* @__PURE__ */ React.createElement("path", { d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" })
        )
      ),
      /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "error-boundary__link",
          title: "Zur Startseite",
          href: homePageLink
        },
        /* @__PURE__ */ React.createElement(
          "svg",
          {
            fill: "currentColor",
            className: "error-boundary__icon",
            focusable: "false",
            "aria-hidden": "true",
            viewBox: "0 0 24 24"
          },
          /* @__PURE__ */ React.createElement("path", { d: "m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z" })
        )
      ),
      /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "error-boundary__link",
          title: BACK_TO_APP_TITLE,
          href: "#",
          onClick: this.handleClose
        },
        /* @__PURE__ */ React.createElement(
          "svg",
          {
            fill: "currentColor",
            className: "error-boundary__icon",
            focusable: "false",
            "aria-hidden": "true",
            viewBox: "0 0 24 24"
          },
          /* @__PURE__ */ React.createElement("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
        )
      )
    ), /* @__PURE__ */ React.createElement("main", { className: "error-boundary", role: "alert" }, /* @__PURE__ */ React.createElement("div", { className: "error-boundary__top" }, /* @__PURE__ */ React.createElement(BugSvg, null), /* @__PURE__ */ React.createElement("div", { className: "error-boundary__text-content" }, /* @__PURE__ */ React.createElement("h1", null, title), /* @__PURE__ */ React.createElement("p", null, description), /* @__PURE__ */ React.createElement("h2", null, "Fehlermeldung:"), /* @__PURE__ */ React.createElement("pre", null, message), /* @__PURE__ */ React.createElement("details", null, /* @__PURE__ */ React.createElement("summary", null, "Stacktrace"), /* @__PURE__ */ React.createElement("pre", null, stack)))))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TestErrorDispatcher$1, null), children);
  }
}
const ErrorBoundary$1 = ErrorBoundary;
export {
  ErrorBoundary$1 as default
};
